import theme from "@/services/providers/GlobalTheme";
import AuthProvider from "@/services/contexts/auth.context";
import { ModalProvider } from "@/services/contexts/modal.context";
import MapProvider from "@/services/contexts/map.context";
import { ThemeProvider } from "@mui/material";
import AdsCreateProvider from "@/services/contexts/ad.create.context";
import NotificationsProvider from "@/services/contexts/notification.context";
import CardsProvider from "@/services/contexts/cards.context";
import { SWRConfig } from "swr";
import fetcher from "@/lib/fetcher";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PlaylistsProvider } from "@/services/contexts/playlist.context";
import { ChatProvider } from "@/services/contexts/chat.context";

function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SWRConfig
      value={{
        fetcher: fetcher,
      }}
    >
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <AuthProvider>
            <ModalProvider>
              <AdsCreateProvider>
                <NotificationsProvider>
                  <CardsProvider>
                    <PlaylistsProvider>
                      <ChatProvider>
                        <MapProvider>{children}</MapProvider>
                      </ChatProvider>
                    </PlaylistsProvider>
                  </CardsProvider>
                </NotificationsProvider>
              </AdsCreateProvider>
            </ModalProvider>
          </AuthProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </SWRConfig>
  );
}

export default Providers;
